const constants = {
  API_URL: process.env.NODE_ENV === 'production' ? 'https://api.grouphug.online/api' : 'http://localhost:3300/api',

  // Subsidy model 2026: show new UI (per-pair session count, etc.) from this date.
  // Change to a past date to test, future date to disable.
  SUBSIDY_2026_START: new Date('2026-05-19T21:00:00.000Z'), // = 20.05.2026 00:00 Israel

  // Feature flag: allow experts to convert a 1TO1 service into a series in the
  // edit dialog. Flip to false to hide the toggle without removing the code.
  ENABLE_SERIES_EDITING: false,

  // Login mode for the experts dashboard. false (default) = passwordless: email -> email OTP.
  // true = require a password before the OTP step. Keep in sync with the backend env var
  // EXPERT_LOGIN_REQUIRE_PASSWORD.
  EXPERT_LOGIN_REQUIRE_PASSWORD: false,

  // GH-761: "which Google calendars block my availability" picker in the calendar-sync tab.
  // Flip to false to hide it without removing the code. The backend has its own switch
  // (EXPERT_CALENDAR_PICKER_ENABLED) that also makes free/busy ignore stored picks.
  CALENDAR_PICKER_ENABLED: true,

  // Gradual rollout (GH-539/625): the "קביעת כמה פגישות עתידיות" icon (deferred payment,
  // form sent 48h before each session) is shown ONLY to experts whose _id is in this list.
  // Add instructor ids to open the feature for them; empty array = off for everyone.
  FUTURE_APPOINTMENTS_EXPERT_IDS: [
    '62f4da77454b14d740800a37', // GroupHug בדיקת מערכת (test)
    '6717887dc46e03fc8042f7cf', // בדיקה בדיקה (test)
    '64b671016622c151cfb09318', // יוליה רובינזון — first real expert (GH-747, 30.9.2026)
  ],
};

export default constants;
